import { Component } from 'react';
import { area as d3Area } from 'd3';

import { type DataPoint, type Series } from './types';

type ScaleFunction = (value: number) => number;

export type AreaProps = Readonly<{
  xScale: ScaleFunction;
  yScale: ScaleFunction;
  x: (d: DataPoint) => number;
  y: (d: DataPoint) => number;
  data: Series;
  height: number;
}>;

export class Area extends Component<AreaProps> {
  public render() {
    const { xScale, yScale, x, y, data, height } = this.props;

    const areaGenerator = d3Area<DataPoint>()
      .x((d) => xScale(x(d)))
      .y0(height)
      .y1((d) => yScale(y(d)));

    const area = areaGenerator(data as DataPoint[]);

    return <path className="Area" d={area || ''} />;
  }
}
